import { useMutation } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { GerritCreateInstallationRequest } from '../httpClients/RepositoryClient/api.schema';
import { MUTATION_KEYS } from './consts';

/**
 * Validates Gerrit credentials in LiteGit and creates the installation,
 * returning its id. Toast-free — the wizard surfaces the user-safe error inline
 * (e.g. the `Administer Server`/`webhooks` plugin prerequisite).
 */
export const useGerritCreateInstallationMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.GERRIT_CREATE_INSTALLATION],
    mutationFn: async (payload: GerritCreateInstallationRequest) =>
      RepositoryClient.gerritCreateInstallation(payload),
  });
